import { useApiUrl, wxApiUrlPrefix } from "@/config/apiUrl.js";
import { isAndroid } from "@/utils/isTerminal";

export default {
  version: 0.1,
  timeout: 60000,
  apiPrefix: "",
  requestRetry: 4,
  requestRetryDelay: 800,
  apiUrl: useApiUrl,
  wxApiUrlPrefix: wxApiUrlPrefix,
  corporation: "公司名教育科技（北京）有限公司",
  siteName: "ElementUi管理后台",
  designSize: 375, //设计稿宽度 375,建议使用375，可以和一些主流的ui库兼容。如vant
  tokenKey: "M_ACCESS_TOKEN",
  userInfoKey: "M_USER_INFO",
  userSource: 2,
  subUserSource: null,
  orgInfo: "M_USER_ORGINFO",
  orgId: "M_USER_ORGID",
  businessSource: 1,
  terminalPlatform: isAndroid ? 3 : 2,
  requestId: new Date().getTime(),
  loginType: "APP", //重要，否则使用登陆系统登陆的 token 没法使用
  agreementUserUrl: "./agreementUser.html", // 用户协议地址
  agreementPrivacyUrl: "./agreementPrivacy.html" // 隐私协议地址
};
